export default {
    isNullOrWhitespace: (input) => {
        return !input || !input.trim();
    }
};

export const
    dateToddmmyyy = (date) => {
        var d = date.getDate();
        var m = date.getMonth() + 1; //Month from 0 to 11
        var y = date.getFullYear();
        return y + '-' + (m <= 9 ? '0' + m : m) + '-' + (d <= 9 ? '0' + d : d);
    };


// Inspiré de "Rendre une adresse url cliquable" sur la page https://www.toutjavascript.com/savoir/savoir22.php3

const urlPattern = /((ht|f)tps?:\/\/\S*)/gi;
const htmlPattern = /(&nbsp;|<([^>]+)>)/ig;
export const
    replaceUrlByLink = (chaine) => {

        let result = chaine.replace(htmlPattern, "");

        return result.replace(urlPattern, "<a target='_blank' href='$1'>$1</a>"); 
    };




export const toUpperCaseNoAccent = (str) => {
    var correctedString = str.toUpperCase();
    correctedString = correctedString.replace(/[ÁÀÄÂ]/, "A");
    correctedString = correctedString.replace(/[ÉÈËÊ]/, "E");
    correctedString = correctedString.replace(/[ÍÌÏÎ]/, "I");
    correctedString = correctedString.replace(/[ÓÒÖÔ]/, "O");
    correctedString = correctedString.replace(/[ÚÙÜÛ]/, "U");

    return correctedString;

};